import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

export default function WeeklyChallenge() {
  const [joined, setJoined] = useState(false);

  return (
    <div className="rounded-xl overflow-hidden" style={{ background: 'linear-gradient(135deg, var(--color-primary) 0%, #2D4A87 100%)' }}>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ background: 'rgba(133,113,77,0.2)' }}>
            <Icon name="Zap" size={16} color="var(--color-accent)" />
          </div>
          <div>
            <p className="font-caption text-xs font-medium" style={{ color: 'rgba(255,255,255,0.6)' }}>Weekly Wealth Challenge</p>
            <p className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>Ends in 4 days</p>
          </div>
        </div>
        <h3 className="font-heading font-semibold text-base text-white mb-1">Track Your Spending for 7 Days</h3>
        <p className="font-caption text-xs mb-3" style={{ color: 'rgba(255,255,255,0.7)' }}>
          Log every expense this week and share your biggest insight with the community. Top 3 insights win $25 WIN credits!
        </p>
        <div className="flex items-center justify-between mb-3">
          <div className="flex -space-x-2">
            {['women/12', 'women/23', 'women/34', 'women/45']?.map((p, i) => (
              <div key={i} className="w-6 h-6 rounded-full border-2 border-white overflow-hidden" style={{ zIndex: 4 - i }}>
                <img src={`https://randomuser.me/api/portraits/${p}.jpg`} alt={`Community member ${i + 1} participating in weekly challenge`} className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
          <span className="font-caption text-xs text-white">+247 joined</span>
        </div>
        <Button
          variant={joined ? 'outline' : 'default'}
          size="sm"
          fullWidth
          onClick={() => setJoined(!joined)}
          iconName={joined ? 'Check' : 'Plus'}
          iconPosition="left"
          iconSize={13}
        >
          {joined ? 'Joined!' : 'Join Challenge'}
        </Button>
      </div>
    </div>
  );
}